module.exports = __webpack_public_path__ + "img/kefu.a4567022.png";